/**
 * Everything that makes this product "this marketplace" and not the next one.
 *
 * The shell (dock, windows, mobile sheets) reads only this file for identity,
 * so re-skinning is one file plus the palette block in index.css.
 */
export const BRAND = {
  /** Shown in the menu bar and on the mobile home screen. */
  name: 'Mộc',
  tagline: 'Sàn bất động sản',
  /** App opened automatically on the desktop shell — the market comes first. */
  bootAppId: 'market',
  /** Key prefix for everything this product persists. */
  storageKey: 'moc-market',
} as const;
